import React from "react";

import FibraVidro from '../componentes/FibraVidro'
import BanhoGel from '../componentes/BanhoGel'
import * as S from './styles'

function Price() {
  return (
    <S.ContainerPrice>
      <FibraVidro />
      <BanhoGel />
    </S.ContainerPrice>
  );
}

export default Price;
